export default "__VITE_ASSET__99707227__"